import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import TagSelector from '@/components/TagSelector';
import useProfileOptions from '@/hooks/useProfileOptions';

export default function ExpertiseTab({ profile, set, handleSave }) {
  const opts = useProfileOptions();
  return (
    <>
      <Card className="p-8 border border-slate-200 mb-6">
        <h2 className="text-lg font-bold font-heading mb-1">Qualifications & Expertise</h2>
        <p className="text-sm text-slate-500 mb-6">Your professional background</p>
        <div className="space-y-6">
          <TagSelector label="Specialist Areas" options={opts.specialist_areas} selected={profile.specialist_areas}
            onChange={(v) => set('specialist_areas', v)} testId="add-specialist-areas-btn" max={6} hint="Your specific areas of logistics expertise" />
          <TagSelector label="Qualifications" options={opts.qualifications} selected={profile.qualifications}
            onChange={(v) => set('qualifications', v)} testId="add-qualifications-btn" max={5} hint="Academic degrees and professional qualifications" />
          <TagSelector label="Expertise & Skills" options={opts.expertise} selected={profile.expertise}
            onChange={(v) => set('expertise', v)} testId="add-expertise-btn" max={6} />
          <TagSelector label="Certifications" options={opts.certifications} selected={profile.certifications}
            onChange={(v) => set('certifications', v)} testId="add-certs-btn" max={5} />
        </div>
      </Card>

      <Card className="p-8 border border-slate-200 mb-6">
        <h2 className="text-lg font-bold font-heading mb-1">Your SLL Journey</h2>
        <p className="text-sm text-slate-500 mb-6">Help us connect you with the right people</p>
        <div className="space-y-6">
          <TagSelector label="What Brings You to SLL" options={opts.community_goals}
            selected={profile.community_goals} onChange={(v) => set('community_goals', v)}
            testId="add-community-goals-btn" max={5} hint="Why did you join?" />
          <TagSelector label="Topics of Interest" options={opts.interests} selected={profile.interests}
            onChange={(v) => set('interests', v)} testId="add-interests-btn" max={6} />
          <TagSelector label="Priorities for 2026" options={opts.priority_2026}
            selected={profile.priorities_2026} onChange={(v) => set('priorities_2026', v)}
            testId="add-priorities-btn" max={5} hint="Key sustainability priorities this year" />
          <TagSelector label="Biggest Challenges" options={opts.challenges} selected={profile.challenges}
            onChange={(v) => set('challenges', v)} testId="add-challenges-btn" max={5} />
        </div>
      </Card>

      <Button data-testid="save-expertise-button" onClick={handleSave}
        className="w-full h-12 text-base bg-gradient-to-r from-brand-navy to-brand-sage hover:from-brand-dark hover:to-brand-sage text-white">
        Save Changes
      </Button>
    </>
  );
}
